module.exports = __webpack_public_path__ + "media/house-beautiful-ee1fbb5e.svg";